module.exports = {
  // COMMON,
  dataValues: {
    advertisements: {
      view: {
        stats: 'Übersicht',
        scheduler: 'Kalender',
        list: 'Liste',
      },
    },
  },
  scheduler: {
    entities: {
      capacity: {
        freeWorkers: 'Nicht eingeteilte Mitarbeiter:',
      },
      absence: {
        restWish: {
          internalEmployee: 'Sperrtage interner Mitarbeiter:',
          externalEmployee: 'Sperrtage externer Mitarbeiter:',
          occasionalEmployee: 'Sperrtage fallweise Mitarbeiter:',
          contractor: 'Sperrtage von Sub-Unternehmern:',
        },
        vacation: {
          internalEmployee: 'Interne Mitarbeiter im Urlaub:',
          externalEmployee: 'Externe Mitarbeiter im Urlaub:',
          occasionalEmployee: 'Fallweise Mitarbeiter im Urlaub:',
          contractor: 'Sub-Unternehmer im Urlaub:',
        },
        sickLeave: {
          internalEmployee: 'Interne Mitarbeiter im Krankenstand:',
          externalEmployee: 'Externe Mitarbeiter im Krankenstand:',
          occasionalEmployee: 'Fallweise Mitarbeiter im Krankenstand:',
          contractor: 'Sub-Unternehmer im Krankenstand:',
        },
        notAvailable: {
          internalEmployee: 'Nicht verfügbare interne Mitarbeiter:',
          externalEmployee: 'Nicht verfügbare externe Mitarbeiter:',
          occasionalEmployee: 'Nicht verfügbare fallweise Mitarbeiter:',
          contractor: 'Nicht verfügbare Sub-Unternehmer:',
        },
      },
      project: {
        scoreTitle: '{{score}} / {{maxScore}} Planstellen weisen überhaupt keine Probleme auf.',
        problemSummary: {
          headlines: {
            project: 'Projekt-Status',
            projectTerm: 'Termin-Status',
            projectTermJobs: 'Planstellen-Status-Zusammenfassung',
          },
        },
      },
    },
  },
  project: {
    mail: {
      urgencyAttention: {
        subject: 'Dringende Projekt-Bearbeitung: #{{projectID}}',
      },
    },
  },
  form: {
    fields: {
      hourlyRate: {
        price: {
          placeholder: '[€/h]',
          innerTitle: 'Preis [€/h]',
        },
        priceCommission: {
          placeholder: '[€/h]',
          innerTitle: 'Preis inkl. Provision [€/h]',
        },
        nrOfHoursUntilOvertimeStart: {
          placeholder: '[h]',
          innerTitle: 'Normalstunden [h]',
        },
        overtimePremiumPercentage: {
          placeholder: '[%]',
          innerTitle: 'Aufschlag [%]',
        },
      },
      flatScale: {
        startHour: {
          placeholder: '[h]',
          innerTitle: 'ab Stunde [h]',
        },
        maxStartHour: {
          placeholder: '[h]',
          innerTitle: 'bis Stunde [h]',
        },
        price: {
          placeholder: '[€]',
          innerTitle: 'Preis [€]',
        },
        priceCommission: {
          placeholder: '[€]',
          innerTitle: 'Preis inkl. Provision [€]',
        },
        priceHourlyRate: {
          placeholder: '[€/h]',
          innerTitle: 'Stundensatz [€/h]',
        },
        priceHourlyRateCommission: {
          placeholder: '[€/h]',
          innerTitle: 'Stundensatz inkl. Provision [€/h]',
        },
      },
      selectEmployeeJobs: {
        emptyJobList: 'Keine Jobs verfügbar',
        showOnRegistrationMarkers: {
          title: 'Bewerbungs-Job',
          message: 'Dieser Job ist als Bewerbungs-Job markiert.',
        },
      },
    },
    employeeProperties: {
      fieldSetHeadlines: {
        properties: 'Eigenschaften',
        invoice: 'Rechnungslegung für externe Mitarbeiter',
        jobs: 'Jobs / Arbeitsbereich',
        domainsAndOther: 'Einsatzgebiete / Sonstiges',
        internalEmployeeOptions: 'Optionen für interne Mitarbeiter',
        application: 'Bewerbung',
      },
      fieldSets: {
        jobs: {
          externalEmployeeJobsAndPricesExplanation: {
            asOffice: 'Für welche Jobs ist der Mitarbeiter geeignet.<br><br>' +
                '<b>Farben:</b> Wenn das Feld links <b>schwarz</b> hinterlegt ist, ist der Job ausgewählt.<br>Der Knopf zum Verwalten der Preise (nur für externe Mitarbeiter verfügbar) wird bei ausgewählten Jobs <b>grün</b> hinterlegt, wenn alle Zeiträume mit Preisen hinterlegt wurden und <b>orange</b> wenn noch mindestens einer fehlt.<br><br>' +
                '<b>Ausschreibungen externer Mitarbeiter:</b> Ausschreibungen werden nur für ausgewählte Jobs mit hinterlegten Preisen für den betroffenen Zeitraum angezeigt.<br><br>' +
                '<b>Ausschreibungen fallweiser Mitarbeiter:</b> Ausschreibungen werden nur für ausgewählte Jobs für den betroffenen Zeitraum angezeigt.',
            asCrew: 'Die nachstehenden Felder sind dazu gedacht auszuwählen welche Jobs man selbst erfüllen möchte.<br><br>' +
                '<b>Farben:</b> Wenn das Feld links <b>schwarz</b> hinterlegt ist, ist der Job ausgewählt.<br>Der Knopf zum Verwalten der Preise wird bei ausgewählten Jobs <b>grün</b> hinterlegt, wenn alle Zeiträume mit Preisen hinterlegt wurden und <b>orange</b> wenn noch mindestens einer fehlt.<br><br>' +
                '<b>Hinweis:</b> Im aktuellen Gültigkeits-Zeitraum sind keine nachträglichen Preis-Änderungen im CrewTool mehr möglich.<br><br>' +
                '<b>Ausschreibungen:</b> Ausschreibungen werden nur für ausgewählte Jobs mit hinterlegten Preisen für den betroffenen Zeitraum angezeigt.',
            asRegistration: 'Die nachstehenden Felder sind dazu gedacht auszuwählen welche Jobs man selbst erfüllen möchte.<br><br>Wenn das Feld links <b>schwarz</b> hinterlegt ist, ist der Job ausgewählt.'
          },
        }
      }
    },
    employeeReportProperties: {
      fieldSetHeadlines: {
        properties: 'Eigenschaften',
      },
    },
    userProperties: {
      fieldSetHeadlines: {
        contact: 'Kontakt-Informationen',
        user: 'User & Berechtigungen',
      },
    },
    projectProperties: {
      allInOne: {
        project: {
          headline: 'Projekt-Eigenschaften',
        },
        projectTerms: {
          headline: 'Projekt-Termine',
        },
      },
    },
    projectTermJobProperties: {
      fieldSetHeadlines: {
        customer: 'Kunden-Angaben',
        office: 'Büro-Angaben',
        employee: 'Mitarbeiter-Angaben',
      },
    },
    projectTermJobMassInsertProperties: {
      fieldSetHeadlines: {
        selectNrOfJobs: {
          title: 'Welche Planstellen werden benötigt?',
          tooltip: 'Tipp: Man kann für das schnelle Verändern einzelner Positionen auch das Mausrad verwenden.',
        },
      },
    },
    jobProperties: {
      fieldSetHeadlines: {
        properties: 'Eigenschaften',
      },
    },
    customerContactProperties: {
      fieldSetHeadlines: {
        properties: 'Eigenschaften',
      },
    },
    contractorContactProperties: {
      fieldSetHeadlines: {
        properties: 'Eigenschaften',
      },
    },
    timeRecordingsProperties: {
      fields: {
        timePickerDefault: 'Für Alle setzen',
      },
    },
    invoiceProperties: {
      fields: {
        url: {
          placeholder: 'Rechnung',
        },
        canceledUrl: {
          placeholder: 'Gutschrift',
        },
        completed: {
          toggle: {
            positive: 'Abgeschlossen',
            negative: 'Abschließen',
          },
          labelKeys: {
            ts: {
              set: 'Abgeschlossen am {{ts}}',
              unset: 'Noch nicht abgeschlossen',
            },
            entity: {
              set: 'von {{title}} {{firstname}} {{lastname}} aka {{nickname}}',
            },
          },
        },
        confirmed: {
          toggle: {
            positive: 'Bestätigt & Versandt',
            negative: 'Bestätigen & Versenden',
          },
          labelKeys: {
            ts: {
              set: 'Bestätigt am {{ts}}',
              unset: 'Noch nicht bestätigt',
            },
            entity: {
              set: 'von {{title}} {{firstname}} {{lastname}} aka {{nickname}}',
            },
          },
        },
        canceled: {
          toggle: {
            positive: 'Storniert & Versandt',
            negative: 'Stornieren & Versenden',
          },
          labelKeys: {
            ts: {
              set: 'Storniert am {{ts}}',
              unset: 'Nicht storniert',
            },
            entity: {
              set: 'von {{title}} {{firstname}} {{lastname}} aka {{nickname}}',
            },
          },
        },
      },
      buttons: {
        redoExplanation: `Die Verarbeitung einer Rechnung ist dann notwendig, wenn sie bestätigt oder nach bereits erfolgter Bestätigung storniert wird und <b>erfolgt automatisch</b>.

Dieser Schritt schließt:
- die Vergabe von Nummern der unterschiedlichen Nummernkreise,
- das Generieren von QR-Codes und PDF-Dateien,
- sowie das Versenden von Mails ein.

Sollte bei der automatischen Verarbeitung etwas schief gehen, kann hier eben diese erneut angestoßen werden.

<b>Tipp:</b> Wenn die Verarbeitung in Ordnung war, aber die Email an den Kunden verloren gegangen ist, kann man durch erneutes Verarbeiten mit geänderter oder gleicher Email-Adresse die Email noch einmal schicken.
Wenn also das "Zuletzt verarbeitet am"-Datum nicht dem "Versandt am"-Datum entspricht war die Verarbeitung maximal teilweise erfolgreich.`,
      },
    },
    absenceProperties: {
      fields: {
        status: {
          prefix: 'Status: ',
          creating: 'Neu',
          requested: 'Beantragt',
          confirmed: 'Bestätigt',
          rejected: 'Abgelehnt',
        },
      },
    },
    registration: {
      employeeExternal: {
        fieldSetHeadlines: {
          properties: 'Persönliches',
          contact: 'Kontakt',
          address: 'Anschrift',
          invoice: 'Firma',
          additionalProperties: 'Sonstiges',
          jobs: 'Jobs / Arbeitsbereich',
          docs: 'Dokumente',
          finish: 'Abschließendes',
        },
      },
      customer: {
        fieldSetHeadlines: {
          properties: 'Firma',
          contact: 'Kontakt',
          address: 'Anschrift',
        },
      },
      customerContact: {
        fieldSetHeadlines: {
          properties: 'Persönliches',
          contact: 'Kontakt',
          address: 'Anschrift',
          additionalProperties: 'Sonstiges',
          finish: 'Abschließendes',
        },
      },
    },
    crewProfile: {
      employeeProperties: {
        fieldSetHeadlines: {
          properties: 'Persönliches',
          contact: 'Kontakt',
          invoice: 'Firma',
          jobs: 'Jobs / Arbeitsbereich',
          docs: 'Dokumente',
        },
      },
    }
  },
  table: {
    head: {
      projects: 'Projekte & Termine',
      projectTerms: 'Termine in diesem Projekt',
      projectTermJobs: 'Planstellen dieses Termins',
      projectTermJobsSummary: 'Planstellen Statistik',
      projectTermJobApplications: 'Ausschreibungs - Bewerber',
      employees: 'Mitarbeiter',
      employeeReports: 'Stundenlisten',
      jobs: 'Jobs',
      jobPrices: 'Preise',
      customers: 'Kunden',
      customerContacts: 'Auftraggeber',
      contractors: 'Sub-Unternehmer',
      contractorContacts: 'Ansprechpartner',
      shippingOrders: 'Lieferscheine',
      documents: 'Lieferscheine / Rechnungen',
      offers: 'Angebote',
      statusFlags: 'Status - Elemente',
      costCenters: 'Kostenstellen',
      selection: {
        projectTerms: 'Termine in diesem Projekt',
      },
      absence: 'Abwesenheiten',
      absenceProjectTermJobConflicts: 'Planstellen - Konflikte'
    },
    jobPrices: {
      fields: {
        price: {
          flatScale: {
            first: '{{price}} für die ersten {{duration}} Stunden',
            next: '{{price}} für die folgenden {{duration}} Stunden',
          },
          hourlyRate: '{{price}} / Stunde',
        },
      },
    },
    projectTermJobs: {
      fields: {
        advertisement: {
          reaction: {
            yes: 'ja',
            no: 'nein',
            open: 'offen',
          },
        },
        status: {
          ok: 'Planstelle bereit',
          not: {
            projectTermJobReady: 'Die Daten für diese Planstelle sind unvollständig.',
            jobReady: 'Der zugewiesene Job ist nicht aktiv.',
            workerActive: 'Der zugewiesene Mitarbeiter ist nicht aktiv.',
            workerCapable: 'Der zugewiesene Mitarbeiter kann den zugewiesenen Job nicht ausführen.',
            read: 'Der zugewiesene Mitarbeiter hat diese Planstelle noch nicht bestätigt.',
          },
          readOutDated: 'Der Zugewiesene Mitarbeiter hat die letzte Änderung dieser Planstelle noch nicht bestätigt.',
        },
      },
    },
    timeRecordings: {
      gotNoData: {
        all: {
          shippingOrder: {
            byProjectEditDeniedReason: {
              permissionChecksImpossibleDueToMissingEmployeeID: 'Deine Rechte im Bezug auf die Lieferschein-Zeiterfassung konnten nicht ermittelt werden.<br><br>Möglicherweise lässt sich das Problem beheben, indem Du dich neu anmeldest.',
              projectIsInternal: 'Interne Projekte unterstützen keine Lieferschein-Zeiterfassung.',
            },
            byProjectTermEditDeniedReason: {
              missingPermissions: 'Es sind keine Termine für die Lieferschein-Zeiterfassung verfügbar. Mindestens ein Termin kann nicht berücksichtigt werden, da Du nicht die nötigen Rechte hast dessen Lieferschein-Zeiten zu erfassen.',
              invalidStart: 'Es sind keine Termine für die Lieferschein-Zeiterfassung verfügbar. Mindestens ein Termin kann nicht berücksichtigt werden, weil noch kein gültiger Beginn eingetragen wurde.',
              maxAgeEdit: 'Es sind keine Termine für die Lieferschein-Zeiterfassung verfügbar. Mindestens ein Termin kann nicht berücksichtigt werden, da er schon zu weit in der Vergangenheit liegt.',
              futureEdit: 'Es sind keine Termine für die Lieferschein-Zeiterfassung verfügbar. Mindestens ein Termin kann nicht berücksichtigt werden, da er noch in der Zukunft liegt.',

              // these should not be possible since there are no shipping orders to be created without projectTerm-specificity
              shippingOrderAlreadyDone: 'Es wurde bereits ein Lieferschein für diese Termine erstellt.',
              shippingOrderCannotBeReplacedByMismatchingReplacementShippingOrderID: 'Diese Termine sind bereits auf einem anderen Lieferschein vertreten. Bitte ersetze den passenden Lieferschein, um die Lieferscheinzeiten neu zu erfassen.',
              shippingOrderCannotBeReplacedBeforeBeingDoneOnce: 'Der Lieferschein der ersetzt werden soll kann nicht gefunden werden.',
              shippingOrderCanBeCreatedForLastInShippingOrderGroupOnly: 'Es konnten keine Termine als letzter ihrer Lieferscheingruppe gefunden werden.',
              shippingOrderHasBeenReplacedAlready: 'shippingOrderHasBeenReplacedAlready',
            },
            missingProjectTerms: 'Es sind keine Termine für die Lieferschein-Zeiterfassung verfügbar.',
            // fallback in case something during error handling goes wrong.
            all: 'Alle verfügbaren Termine und deren Jobs sind bereits einem Lieferschein zugeordnet, oder bereits soweit in der Vergangenheit, dass ein Bearbeiten der Lieferschein-Zeiten nicht mehr erlaubt ist.',
          },
          timeRegistration: {
            byProjectEditDeniedReason: {
              permissionChecksImpossibleDueToMissingEmployeeID: 'Deine Rechte im Bezug auf die Zeiterfassung konnten nicht ermittelt werden.<br><br>Möglicherweise lässt sich das Problem beheben, indem Du dich neu anmeldest.',
              projectIsInternal: 'Interne Projekte unterstützen keine Zeiterfassung.',
            },
            byProjectTermEditDeniedReason: {
              missingPermissions: 'Es sind keine Termine für die Zeiterfassung verfügbar. Mindestens ein Termin kann nicht berücksichtigt werden, da Du nicht die nötigen Rechte hast dessen Zeiten zu erfassen.',
              invalidStart: 'Es sind keine Termine für die Zeiterfassung verfügbar. Mindestens ein Termin kann nicht berücksichtigt werden, weil noch kein gültiger Beginn eingetragen wurde.',
              maxAgeEdit: 'Es sind keine Termine für die Zeiterfassung verfügbar. Mindestens ein Termin kann nicht berücksichtigt werden, da er schon zu weit in der Vergangenheit liegt.',
              futureEdit: 'Es sind keine Termine für die Zeiterfassung verfügbar. Mindestens ein Termin kann nicht berücksichtigt werden, da er noch in der Zukunft liegt.',
            },
            missingProjectTerms: 'Es sind keine Termine für die Zeiterfassung verfügbar.',
            // fallback in case something during error handling goes wrong.
            all: 'Es sind keine Termine für die Zeiterfassung verfügbar.',
          },
        },
        projectTerm: {
          shippingOrder: {
            byProjectEditDeniedReason: {
              permissionChecksImpossibleDueToMissingEmployeeID: 'Deine Rechte im Bezug auf die Lieferschein-Zeiterfassung konnten nicht ermittelt werden.<br><br>Möglicherweise lässt sich das Problem beheben, indem Du dich neu anmeldest.',
              projectIsInternal: 'Interne Projekte unterstützen keine Lieferschein-Zeiterfassung.',
            },
            byProjectTermEditDeniedReason: {
              missingPermissions: 'Du hast nicht die nötigen Rechte, um Lieferscheinzeiten für diesen Termin zu erfassen.',
              invalidStart: 'Die Lieferschein-Zeiterfassung kann nicht gestartet werden, da dieser Termin keinen gültigen Beginn eingetragen hat.',
              maxAgeEdit: 'Dieser Termin liegt zu weit in der Vergangenheit, um die Lieferschein-Zeiterfassung noch zu starten.',
              futureEdit: 'Dieser Termin beginnt erst in der Zukunft, welhalb die Lieferschein-Zeiterfassung noch nicht gestartet werden kann.',
              shippingOrderAlreadyDone: 'Es existiert bereits ein Lieferschein für diesen Termin.<br><br>Um den Lieferschein zu Korrekturzwecken zu ersetzen, kannst Du dazu den zugehörigen Knopf in der Lieferschein-Liste verwenden.',
              shippingOrderCannotBeReplacedByMismatchingReplacementShippingOrderID: 'Dieser Termin ist bereits auf einem anderen Lieferschein vertreten. Bitte ersetze den Lieferschein, der diesem Termin zugeordnet ist, um die Lieferscheinzeiten neu zu erfassen.',
              shippingOrderCannotBeReplacedBeforeBeingDoneOnce: 'Dieser Termin ist noch auf keinem Lieferschein vertreten und kann deshalb auch nicht ersetzt werden.',
              shippingOrderCanBeCreatedForLastInShippingOrderGroupOnly: 'Dies ist nicht der letzte Termin in der Lieferschein-Gruppe.',
              shippingOrderHasBeenReplacedAlready: 'Dieser Lieferschein wurde bereits storniert und kann deshalb nicht mehr ersetzt werden.',
            },
            missingProjectTerms: 'Für diesen Termin ist keine Lieferschein-Zeiterfassung verfügbar.',
            // fallback in case something during error handling goes wrong.
            all: 'Für diesen Termin ist keine Lieferschein-Zeiterfassung verfügbar.<br><br>Das kann daran liegen, dass dieser Termin noch in der Zukunft liegt, zu weit in der Vergangenheit liegt, bereits ein Lieferschein für diesen Termin existiert, oder Dir die dafür nötigen Rechte fehlen.',
          },
          timeRegistration: {
            byProjectEditDeniedReason: {
              permissionChecksImpossibleDueToMissingEmployeeID: 'Deine Rechte im Bezug auf die Zeiterfassung konnten nicht ermittelt werden.<br><br>Möglicherweise lässt sich das Problem beheben, indem Du dich neu anmeldest.',
              projectIsInternal: 'Interne Projekte unterstützen keine Zeiterfassung.',
            },
            byProjectTermEditDeniedReason: {
              missingPermissions: 'Du hast nicht die nötigen Rechte, um die Zeiten für diesen Termin zu erfassen.',
              invalidStart: 'Die Zeiterfassung kann nicht gestartet werden, da dieser Termin keinen gültigen Beginn eingetragen hat.',
              maxAgeEdit: 'Dieser Termin liegt zu weit in der Vergangenheit, um die Zeiterfassung noch zu starten.',
              futureEdit: 'Dieser Termin beginnt erst in der Zukunft, welhalb die Zeiterfassung noch nicht gestartet werden kann.',
            },
            missingProjectTerms: 'Für diesen Termin ist keine Zeiterfassung verfügbar.',
            // fallback in case something during error handling goes wrong.
            all: 'Für diesen Termin ist keine Zeiterfassung verfügbar.<br><br>Das kann daran liegen, dass dieser Termin noch in der Zukunft liegt, zu weit in der Vergangenheit liegt, oder Dir die nötigen Rechte fehlen die Zeiterfassung durchzuführen.',
          },
        },
      },
    },
    statusFlags: {
      authority: {
        office: 'Büro',
        crew: 'Crew',
        customer: 'Kunde',
        any: '?',
      },
    },
    costCenters: {
      additionalCostCenters: 'Sonder-Kostenstellen',
    },
    documents: {
      invoices: {
        getOrCreate: {
          editDeniedReason: {
            missingInvoice: 'Die Rechnung konnte nicht gefunden werden.',
            missingShippingOrder: 'Der Lieferschein konnte nicht gefunden werden.',
            missingProject: 'Das Projekt zu diesem Lieferschein konnte nicht gefunden werden.',
            projectIsInternal: 'Interne Projekte unterstützen weder Lieferscheine noch Rechnungen.',
          },
        }
      },
    },
  },



  // SPECIAL,
  scopes: {
    names: {
      office: 'Back-Office',
      crew: 'Mitarbeiter-Portal',
      customers: 'Kunden-Portal',
      contractors: 'Sub-Unternehmer-Portal',
      forum: 'Forum',
    },
  },
  modal: {
    showInsert_projects: {
      title: 'Neues Projekt anlegen',
    },
    showInsert_projectTerms: {
      title: 'Neuen Termin anlegen',
    },
    showInsert_projectTermJobs: {
      title: 'Planstelle hinzufügen',
    },
    showInsert_projectTermJobs_mass: {
      title: 'Planstellen hinzufügen',
    },
    showEdit_projects: {
      title: 'Projekt bearbeiten',
    },
    showEdit_projectTermJobs: {
      title: 'Planstelle bearbeiten',
    },
    showList_projectTermJobs: {
      title: 'Planstellen bearbeiten',
    },
    showList_documents: {
      title: 'Dokumente',
    },
    showInsert_employees: {
      title: 'Neuen Mitarbeiter anlegen',
    },
    showInsert_jobs: {
      title: 'Neuen Job anlegen',
    },
    showEdit_jobs: {
      title: 'Job bearbeiten',
    },
    showSelect_jobPrice_timeRange: {
      title: 'Gültigkeits-Zeitraum wählen',
    },
    showInsert_priceConfigs: {
      title: 'Preis-Konfiguration anlegen',
    },
    showInsert_prices: {
      title: 'Preis anlegen',
    },
    showEdit_prices: {
      title: 'Preis bearbeiten',
    },
    showInsert_prices_asCrew: {
      title: 'Preis anlegen',
    },
    showEdit_prices_asCrew: {
      title: 'Preis bearbeiten',
    },
    showEdit_employeeJobPrices: {
      title: 'Preise bearbeiten',
    },
    instantImageUploader: {
      title: 'Bild(er) hochladen',
      titles: {
        companyLogo: 'Firmen-Logo',
        photo: 'Foto',
      },
    },
    instantFileUploader: {
      title: 'Datei(en) hochladen',
      titles: {
        tradeCertificate: 'Gewerbeschein',
        additionalApplicationFiles: 'Weitere Uploads',
      },
    },
    showInsert_customers: {
      title: 'Kunde anlegen',
    },
    showInsert_customerContacts: {
      title: 'Auftraggeber anlegen',
    },
    showInsert_contractors: {
      title: 'Sub-Unternehmer anlegen',
    },
    showInsert_contractorContacts: {
      title: 'Ansprechpartner anlegen',
    },
    showEdit_timeRecordings: {
      titles: {
        timeRegistration: 'Zeiterfassung',
        shippingOrder: 'Lieferschein-Zeiten',
      },
    },
    showEdit_timeRecord: {
      title: 'Anwesenheit',
    },
    showEdit_shippingOrders: {
      title: 'Lieferscheine',
      subTitles: {
        all: 'im Projekt',
        projectTerm: 'für Termin',
      },
    },
    showEdit_statusFlags: {
      title: 'Status',
      project: {
        title: 'Projekt - Status',
      },
    },
    showEdit_statusFlags_slim: {
      title: 'Status',
      project: {
        title: 'Projekt - Status',
      },
    },
    showEdit_invoice: {
      title: 'Rechnung bearbeiten',
    },
    showEdit_costCenters: {
      title: 'Kostenstelle bearbeiten',
    },
    showInsert_costCenters: {
      title: 'Kostenstelle anlegen',
    },
    credentials: {
      showReLogin: {
        title: 'Anmeldung',
        dialogText: 'Deine Sitzung ist abgelaufen - Bitte gib deine Benutzerdaten erneut ein.',
      },
      showReset: {
        title: 'Passwort zurücksetzen',
        dialogText: 'Bitte fülle das unten stehende Formular aus um dein Passwort zurück zu setzen. Du erhältst direkt im Anschluss eine E-Mail mit deinen neuen Zugangsdaten.',
      },
      showRegister: {
        title: 'Registrieren',
        dialogText: 'Bitte fülle das unten stehende Formular aus um Dich neu zu registrieren. Du erhältst direkt im Anschluss eine E-Mail mit deinen Zugangsdaten.',
      },
    },
    showAdminPanel: {
      title: 'Admin Panel',
    },
    showEdit_advertisements: {
      title: 'Ausschreibung',
    },
    showSelect_targetProjects: {
      title: 'Ziel-Projekt wählen',
    },
    showSelect_projectTerms_moveToProject: {
      title: 'Projekt-Termine wählen',
      subTitle: 'Welche Projekt-Termine sollen in ein anderes Projekt verschoben werden?',
    },
    showSelect_employeeViaApplication: {
      title: 'Bewerber wählen',
    },
    showInsert_absence: {
      title: 'Abwesenheit anlegen',
    },
    showEdit_absence: {
      title: 'Abwesenheit bearbeiten',
    },
    showSelect_workingTimeExport_timeRange: {
      title: 'Zeitraum wählen',
    },
    showEdit_employeeReports: {
      title: 'Stundenliste bearbeiten',
    },
    showSelect_nrOfElementsPerJob: {
      title: 'Anzahl der Planstellen pro Job wählen',
    },
    showSelect_targetCustomer: {
      title: 'Ziel-Kunde auswählen',
    }
  },
  hint: {
    delete: {
      really: {
        projects: {
          title: 'Sicher?',
          message: 'Bist Du dir sicher, dass Du dieses Projekt irreversibel löschen möchten?',
        },
        projectTerms: {
          title: 'Sicher?',
          message: 'Bist Du dir sicher, dass Du diesen Termin irreversibel löschen möchten?',
        },
        projectTermJobs: {
          title: 'Sicher?',
          message: 'Bist Du dir sicher, dass Du diese Planstelle irreversibel löschen möchten?',
        },
        costCenter: {
          title: 'Sicher?',
          message: 'Bist Du dir sicher, dass Du diese Kostenstelle irreversibel löschen möchten?',
        },
        absence: {
          title: 'Sicher?',
          message: 'Bist Du dir sicher, dass Du diese Abwesenheit irreversibel löschen möchten?',
        },
      },
    },
    addPricesAfterPriceConfigsOnly: {
      title: 'Standard-Preis-Konfiguration fehlt.',
      message: 'Preise können erst eingegeben werden, wenn für den angegebenen Zeitraum die Standard-Preis-Konfiguration angelegt wurde.\n\nMöchtest Du das jetzt tun?',
    },
    addPricesAfterJobsOnly: {
      message: 'Preise können erst eingegeben werden, wenn der jeweilige Job angelegt wurde!',
    },
    addPricesAfterPriceConfigValidStarted: {
      message: 'Der angegebene Gültigkeits-Zeitraum hat bereits begonnen. Das verhindert ein nachträgliches Bearbeiten dieses Preises im Crew-Tool.<br><br>Bitte prüfe Deine Eingaben genau bevor Du sie speicherst.',
    },
    priceAlreadyExistsForThisJob: {
      title: 'Preis bereits angelegt.',
      message: 'Der Preis für den gewählten Gültigkeitszeitraum wurde bereits angelegt.',
    },
    priceAlreadyExistsForThisJobSwitchToEdit: {
      title: 'Preis bereits angelegt.',
      message: 'Der Preis für den gewählten Gültigkeitszeitraum wurde bereits angelegt. Möchtest Du den angelegt Preis bearbeiten?',
    },
    customers: {
      order: {
        lastOfferTS: 'Letztes Angebot vom {{ts}}',
        mandatoryFieldsAsterisk: '*) Die mit * markierten Felder sind Pflichtfelder, die ausgefüllt werden müssen.',
        byStatusCode: {
          preStatus: '',
          draft: 'Dieses Projekt befindet sich noch in der Entwurfs-Phase. Du kannst also noch beliebig Details überprüfen und ändern.',
          request: 'Dieses Projekt befindet sich seit {{ts}} in der Anfrage-Phase. Das bedeutet, dass unser Team gerade prüft, ob wir diesen Auftrag annehmen können.<br><br>Du musst diese Überprüfung nicht abwarten und kannst auch gleich bestellen, wenn Du das möchtest.',
          confirmed: 'Dieses Projekt wurde am {{ts}} bestätigt. Das bedeutet, dass wir diesen Auftrag übernehmen können und uns über eine Bestellung freuen würden.',
          ordered: 'Dieses Projekt wurde am {{ts}} zahlungspflichtig bestellt. Bitte habe einen Moment Geduld während unser Team den Auftrag fixiert.',
          fixed: 'Dieses Projekt wurde am {{ts}} fixiert. Damit steht der Durchführung nichts mehr im Wege.',
          canceled: 'Dieses Projekt wurde am {{ts}} kundenseitig storniert.',
          rejected: 'Unser Team kann diesen Auftrag leider nicht übernehmen.',
        },
        buttonHints: {
          request: 'Wenn Du das Projekt für eine unverbindliche Anfrage einreichst, prüft unser Team ob wir die nötigen Arbeitsstunden leisten können um dein Projekt umzusetzen.',
          requestOffer: 'Klicke hier, um ein neues Angebot des aktuellen Projekts einzuholen. Wenn Du einfach ein bereits bestehendes Angebot einsehen möchtest, kannst Du den Knopf: "Zu den Dokumenten" verwenden.<br><br>Bitte berücksichtige, dass ein Angebot nachträglich nicht mehr verändert werden kann. Wenn sich deine Angaben also noch ändern, sollte ein neues Angebot eingeholt werden.',
          order: 'Klicke hier um kostenpflichtig zu bestellen. Nach ehest möglicher Überprüfung wird unser Team dieses Projekt fixieren.',
          cancel: 'Klicke hier um dieses Projekt zu stornieren.',
          documents: 'Hier kannst Du alle Dokumente (Angebote, Lieferscheine, Rechnungen, etc.) dieses Projekts einsehen.',
        },
      },
    },
  },
  projects: {
    properties: {
      fields: {
        status: {
          subLabel: `Letzte Zustandsänderung vom {{ts}}`,
        },
      }
    },
    summary: {
      nrOfElements: 'Sichtbare Projekte',
      nrOfMatchingElements: 'Gefilterte Projekte',
      nrOfAllElements: 'Alle Projekte',
    },
    crewViewer: {
      fields: {
        customer: {
          name: 'Firma',
        },
        customerContact: {
          name: 'Projekt-Leiter',
        },
        personInChargeEmployee: {
          name: 'Sachbearbeiter',
        },
        manager: {
          name: 'Tages-Verantwortlicher',
        },
      },
      createShippingOrderAfterTimeRecordings: {
        title: 'Lieferschein erstellen?',
        message: 'Möchtest Du jetzt einen Lieferschein anlegen?',
      },
      createShippingOrderAfterTimeRecordingsImpossibleDueToMissingShippingOrderTimes: {
        message: 'Bei diesem Termin müsste ein Lieferschein erstellt werden, was leider nicht möglich ist, da bei mindestens einem Termin innerhalb dieser Lieferschein-Gruppe noch Lieferschein-Zeiten fehlen.',
      },
      insertShippingOrderWithoutProjectTermContext: {
        message: 'Alle Projekt-Termine sind zu vorgefertigten Lieferschein-Gruppen zusammengefasst. Lieferscheine können nur erstellt werden, wenn alle zugehörigen Termine einer Gruppe gültige Lieferscheinzeiten eingetragen bekommen haben. Wenn das der Fall ist, kann man mit dem Lieferschein- oder Zeiterfassungs-Knopf des letzten Termins der Gruppe - gekennzeichnet durch das rote, grüne oder graue Lieferschein-Symbol beim Datum - einen Lieferschein anlegen.',
      },
      replaceShippingOrderHint: {
        title: 'Lieferschein ersetzen?',
        message: 'Das Bearbeiten eines Lieferscheins ist prinzipiell nicht möglich. Bei diesem Vorgang wird ein neuer Lieferschein erstellt und der alte ungültig markiert. Möchtest Du das jetzt tun?',
      },
      modals: {
        showFullText: {
          title: 'Info',
        },
      },
      common: {
        projectNotFound: 'Dieses Projekt konnte nicht gefunden werden.',
      },
    },
    crewTermViewer: {
      fields: {
        infoForManager: {
          name: 'Info für Crewleiter',
        },
        infoForAll: {
          name: 'Info',
        },
        time: {
          name: 'Zeitfenster',
          value: '{{time}} Uhr',
          valueFull: '{{time}} für {{duration}} [h]',
        },
        location: {
          name: 'Location',
        },
        job: {
          name: 'Job',
        },
        skills: {
          name: 'Erforderliche Kompetenzen',
        },
        catering: {
          name: 'Catering',
        },
        colleagues: {
          name: 'Kollegen',
        },
        contact: {
          name: 'Ansprechpartner',
        },
        customer: {
          name: 'Firma',
        },
      },
      lastCoreUpdate: 'letztes Update vom {{date}} um {{time}} Uhr',
    },
    setStatusByCustomer: {
      request: {
        title: 'Hinweis',
        message: 'Bitte beachte, dass nach diesem Schritt die Daten dieses Projekts nur mehr vom VSB-Team verändert werden können.<br><br>Sind alle Details, Termine und Planstellen richtig und vollständig eingegeben?',
      },
      order: {
        title: 'Kostenpflichtig bestellen',
        message: 'Bitte beachte, dass nach diesem Schritt die Daten dieses Projekts nur mehr vom VSB-Team verändert werden können.<br><br>Sind alle Details, Termine und Planstellen richtig und vollständig eingegeben?',
        acceptTerms: {
          title: 'AGB',
          message: 'Bitte bestätige hiermit, dass Du unsere <a href="{{termsUrl}}", target="_blank">AGB</a> gelesen und akzeptiert hast, um fortzufahren.',
        }
      },
      cancel: {
        title: 'Stornieren',
        message: 'Bitte beachte, dass abhängig vom Zeitpunkt Storno-Gebühren anfallen können. Bist Du sicher, dass Du fortfahren möchtest?',
      },
      submitBeforeChangeStatus: {
        title: 'Speichern',
        message: 'Es wurden nicht gespeicherte Änderungen im Projekt gefunden, die gespeichert werden müssen bevor Du fortfahren kannst. Möchtest Du jetzt speichern?',
      },
      thanks: {
        title: 'Danke',
        message: 'Danke für dein Interesse. Wir werden deinen Auftrag baldmöglichst bearbeiten und freuen uns auf eine gute Zusammenarbeit.',
        urgent: {
          title: 'Danke',
          message: 'Danke für dein Interesse. Wir werden deinen Auftrag baldmöglichst bearbeiten und freuen uns auf eine gute Zusammenarbeit.<br><br>Leider ist mindestens einer der Termine schon recht bald. Solltest Du also nicht bald von uns hören bitten wir, Dich telefonisch unter <b>+43 676 428 32 30</b> bei uns zu melden.<br><br>Vielen Dank',
        },
      },
    },
    requestOfferByCustomer: {
      submitBeforeRequestOffer: {
        title: 'Speichern',
        message: 'Es wurden nicht gespeicherte Änderungen im Projekt gefunden, die gespeichert werden müssen bevor Du fortfahren kannst. Möchtest Du jetzt speichern?',
      },
    },
    advertisements: {
      fields: {
        time: {
          value: '{{time}} Uhr',
          valueFull: '{{time}} für {{duration}} [h]',
        },
      },
      status: {
        none: 'Keine Angabe',
        applied: 'Beworben',
        waitlisted: 'Auf Warteliste',
        agreed: 'Zuschlag bestätigt',
        revoked: 'Abgelehnt',
        explanation: {
          statusOutDated: 'Status gültig bis zur letzten Kerndaten-Änderung am {{date}} um {{time}} Uhr.',
          valid: 'Status aktuell',
        },
      },
    },
  },
  advertisements: {
    status: {
      none: 'Keine Angabe',
      applied: 'Beworben',
      waitlisted: 'Auf Warteliste',
      agreed: 'Zuschlag bestätigt',
      revoked: 'Abgelehnt',
      explanation: {
        statusOutDated: 'Status gültig bis {{date}} {{time}}',
        valid: 'Status aktuell',
      },
    },
    stats: {
      types: {
        overall: 'Alle künftigen Ausschreibungen',
        new: 'Alle neuen Ausschreibungen',
        outDated: 'Neu zu bewertende Ausschreibungen',
        positive: 'Bewerbungen',
        negative: 'Ablehnungen',
      },
      typeInfos: {
        new: 'Alle künftigen Ausschreibungen auf die noch nicht reagiert wurde zählen als neu.',
        outDated: 'Wenn sich die Kerndaten von Ausschreibungen ändern müssen die Reaktionen erneuert werden.',
        positive: 'Hierzu zählen alle Ausschreibungen, auf die positiv reagiert wurde.<br>Also: <b>Beworben</b>, <b>Auf der Warteliste</b> oder <b>Zugesagt</b>.',
      },
    },
    showProcess: {
      intro: {
        title: 'Abarbeitung starten?',
        message: 'Es wurden {{nrOfElements}} Ausschreibungen gefunden, auf die man reagieren müsste.\n\nMöchtest Du die Abarbeitung jetzt starten?',
      },
      noData: 'Es wurden keine Ausschreibungen gefunden, auf die man reagieren müsste.',
      noTable: 'Bei der Abarbeitung ist ein Fehler aufgetreten. Möglicherweise kann das Problem durch ein Neuladen der Seite behoben werden.',
    },
  },
  employees: {
    summary: {
      nrOfElements: 'Sichtbare Mitarbeiter',
      nrOfMatchingElements: 'Gefilterte Mitarbeiter',
      nrOfAllElements: 'Alle Mitarbeiter',
    },
    showSelectTimeRangeIntro: 'Bitte wähle den Monat für den die Mitarbeiter-Stundenlisten exportiert werden sollen. Pro Mitarbeiter wird eine Datei erstellt.',
  },
  employeeReports: {
    summary: {
      nrOfElements: 'Sichtbare Stundenlisten',
      nrOfMatchingElements: 'Gefilterte Stundenlisten',
      nrOfAllElements: 'Alle Stundenlisten',
    },
    export: {
      exportAllHint: {
        title: 'Sicher?',
        message: 'Du bist im Begriff alle verfügbaren {{nrOfEntries}} Stundenlisten herunterzuladen.\n\nSollte das ein Versehen sein stelle bitte zuvor die nötigen Filter links neben der Tabelle ein.\nWenn das deine Absicht ist drücke bitte \'Ja\' um fortzufahren.',
      },
      innerFileNotes: {
        dayTimeWorkingHoursDiscrepancy: 'Dieser Wert unterscheidet sich von der Summe der Tabelle, weil die IST-Zeiten von verschiedenen Planstellen dieses Mitarbeiters überlappen.',
      },
    },
    crewView: {
      baseInformation: {
        overall: 'Stand:<br>{{hours}}',
      },
    },
  },
  jobs: {
    summary: {
      nrOfElements: 'Sichtbare Jobs',
      nrOfMatchingElements: 'Gefilterte Jobs',
      nrOfAllElements: 'Alle Jobs',
    },
    picker: {
      jobFlagExtensions: {
        showOnRegistration: '[b]'
      }
    },
  },
  prices: {
    showSelectTimeRangeIntro: 'Bitte wähle den Zeitraum für den der neue Preis gültig sein soll.',
    asCrew: {
      noPriceAvailable: 'Kein Preis festgelegt',
      noPriceConfigAvailable: 'Preis-Konfiguration nicht verfügbar',
    },
    priceTiles: {
      headline: 'Zeitraum:',
    },
  },
  customers: {
    summary: {
      nrOfElements: 'Sichtbare Kunden',
      nrOfMatchingElements: 'Gefilterte Kunden',
      nrOfAllElements: 'Alle Kunden',
    },
  },
  contractors: {
    summary: {
      nrOfElements: 'Sichtbare Sub-Unternehmer',
      nrOfMatchingElements: 'Gefilterte Sub-Unternehmer',
      nrOfAllElements: 'Alle Sub-Unternehmer',
    },
  },
  document: {
    general: {
      pageNumberPrefix: 'Seite',
    },
    shippingOrder: {
      head: 'LIEFERSCHEIN',
      number: 'LNr.: {{value}}',
      customerNumber: 'KNr.: {{value}}',
      projectTitle: 'Projekt',
      timeRange: 'Zeitraum',
      customerReference: 'Kunden-Referenz',
    },
    invoice: {
      head: 'RECHNUNG',
      number: 'RNr.: {{value}}',
      customerNumber: 'KNr.: {{value}}',
      projectTitle: 'Projekt',
      timeRange: 'Zeitraum',
      customerReference: 'Kunden-Referenz',
      vat: '{{value}} % USt.',
      sum: 'Rechnungssumme',
      overtime: 'inklusive ÜST & Zuschläge',
      scale: 'pauschal',
      mail: {
        subject: 'Rechnung {{number}}',
      },
    },
    creditNote: {
      head: 'GUTSCHRIFT',
      number: 'GNr.: {{value}}',
      customerNumber: 'KNr.: {{value}}',
      projectTitle: 'Projekt',
      timeRange: 'Zeitraum',
      customerReference: 'Kunden-Referenz',
      vat: '{{value}} % USt.',
      sum: 'Gutschriftssumme',
      mail: {
        subject: 'Gutschrift {{number}}',
      },
    },
    offer: {
      head: 'ANGEBOT',
      number: 'ANr.: {{value}}',
      customerNumber: 'KNr.: {{value}}',
      projectTitle: 'Projekt',
      timeRange: 'Zeitraum',
      customerReference: 'Kunden-Referenz',
      vat: '{{value}} % USt.',
      sum: 'Angebotssumme',
      overtime: 'inklusive ÜST & Zuschläge',
      scale: 'pauschal',
    },
  },
  statusFlags: {
    severity: {
      ok: 'OK',
      info: 'Info',
      warning: 'Warnung',
      error: 'Fehler',
    },
    summary: {
      nrOfElements: 'Sichtbare Status-Elemente',
      nrOfMatchingElements: 'Gefilterte Status-Elemente',
      nrOfAllElements: 'Alle Status-Elemente',
    },
  },
  invoiceSummary: {
    head: {
      nrOfCostCenters: 'Anzahl der Kostenstellen:',
      netPrice: 'Preis (netto):',
      vatPrice: 'zzgl. MwSt.:',
      price: 'Preis (brutto):',
      sentAt: 'Versandt am:',
      lastProcessedAt: 'Zuletzt verarbeitet am:',
    },
    body: {
      sentAt: '{{date}} um {{time}} Uhr',
      lastProcessedAt: '{{date}} um {{time}} Uhr',
    },
  },
  absence: {
    summary: {
      nrOfElements: 'Sichtbare Abwesenheiten',
      nrOfMatchingElements: 'Gefilterte Abwesenheiten',
      nrOfAllElements: 'Alle Abwesenheiten',
    },
  },
  userController: {
    reloadAfterReloginMandatingUserChanges: 'Nachdem sich gerade Dein Benutzer maßgeblich verändert hat ist ein Neu-Laden unumgänglich.',
  },
  dashboard: {
    tooltips: {
      absences: {
        message: 'Hier werden alle zukünftigen Abwesenheiten angezeigt, die noch bearbeitet werden müssen. Das kann daran liegen, dass noch eine Genehmigung erteilt werden muss, oder ein Konflikt mit der Planstellen-Einteilung besteht.<br><br>Das Diagramm zeigt wie viele zukünftige Abwesenheiten keine Bearbeitung mehr erfordern.',
      },
      employees: {
        // TODO: missing prices
        message: 'Hier werden alle Mitarbeiter angezeigt, die noch bearbeitet werden müssen. Im Moment sind das Bewerber, die noch nicht angenommen oder abgelehnt worden sind.<br><br>Das Diagramm zeigt wie viele Mitarbeiter keine Bearbeitung mehr erfordern und sich innerhalb der letzten drei Monate beworben haben bzw. angelegt wurden.',
      },
      documents: {
        message: 'Hier werden alle nicht abgerechneten Lieferscheine angezeigt.<br><br>Das Diagramm zeigt wie viele Lieferscheine mit Terminen seit Montag letzter Woche bereits bestätigt abgerechnet wurden.',
      },
      projectTerms: {
        message: 'Hier werden alle Projekt-Termine von Montag vor zwei Wochen bis Ende nächster Woche angezeigt, bei denen eine Benutzer-Aktion erfolderlich ist. Diese Liste funktioniert ähnlich wie der Kalender-Filter "Aktion erforderlich".<br><br>Das Diagramm zeigt wie viele Projekt-Termine keine Bearbeitung mehr erfordern.',
      },
      projectTermsByProjectStatus: {
        // message: 'Hier werden alle Projekt-Termine von Montag vor zwei Wochen bis Ende nächster Woche angezeigt, dessen Projekt noch nicht fixiert wurde.<br><br>Das Diagramm zeigt wie viele Projekt-Termine ein fixiertes Projekt hinterlegt haben.',
        message: 'Hier werden alle künftigen Projekt-Termine (die nach heute um 00:00 Uhr enden) angezeigt, dessen Projekt noch nicht fixiert wurde.<br><br>Das Diagramm zeigt wie viele Projekt-Termine ein fixiertes Projekt hinterlegt haben.',
      },
      revenue: {
        message: 'In diesem Diagramm wird der netto Umsatz pro Monat im Bezug auf das Rechnungsdatum angezeigt. Die Durchnnittswerte werden über alle verfügbaren Jahre exklusive dem Heurigen errechnet.',
      },
      workload: {
        // message: 'Hier werden alle zukünftigen Abwesenheiten angezeigt, die noch genehmigt oder abgelehnt werden müssen.<br><br>Das Diagramm zeigt wie viele Abwesenheiten keine Bearbeitung mehr erfordern.',
      },
    },
    elements: {
      title: {
        absence: 'Abwesenheiten',
        employees: 'Mitarbeiter',
        documents: 'Dokumente',
        projectTerms: 'Projekt-Termine',
        projectTermsByProjectStatus: 'Projekt-Termine',
        revenue: 'Umsatz',
        workload: 'Auslastung',
      },
      chartTitle: {
        done: 'Erledigt',
        fixed: 'Fixiert',
      },
    },
  },


  status: {
    activationRegister: {
      successUserMessages: {
        setStatusActive: 'Dein Benutzer wurde aktiviert und kann ab sofort verwendet werden.',
        setEmailConfirmed: 'Deine E-Mail-Adresse wurde bestätigt.',
        setMobileConfirmed: 'Deine Rufnummer wurde bestätigt.',
        password: 'Dein neues Passwort wurde gesetzt und kann ab sofort verwendet werden.<br>Bitte notier es Dir gleich damit es nicht verloren geht.',
      },
    },
  },


  // USER COMMUNICATION
  mails: {
    userEmailConfirmation: {
      confirm: {
        subject: 'E-Mail-Adresse bestätigen',
        content: 'Bitte bestätige mit dem folgenden Link deine E-Mail-Adresse: \n\n{{-activationUrl}}',
      },
      sendPassword: {
        subject: 'Zugangsdaten abrufen',
        content: 'Mit dem folgenden Link kannst Du deine Zugangsdaten abrufen: \n\n{{-activationUrl}}',
      },
    },
  },
  sms: {
    userMobileConfirmation: {
      confirm: 'Bitte bestätige mit dem folgenden Link deine Rufnummer: \n\n{{-activationUrl}}',
      sendPassword: 'Mit dem folgenden Link kannst Du deine Zugangsdaten abrufen:\n\n{{-activationUrl}}',
    },
    notifications: {
      employee: {
        projectTermChange: 'Der folgende Projekt-Termin wurde gerade kurzfristig geändert:\n\n{{-url}}',
      },
    },
  },
}